export default {"src":"/_next/static/media/pair-2.fa6cb489.svg","height":343,"width":366,"blurWidth":0,"blurHeight":0};